import { useState } from "react";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";

import AuthForm from "../../components/Auth/AuthForm";
import AuthHeader from "../../components/Auth/AuthHeader";
import AuthFooter from "../../components/Auth/AuthFooter";
import styles from "./LoginPage.module.css";
import TemplateAuthentication from "../../components/UI/TemplateAuthentication";
import GoogleAuth from "./GoogleAuth";
import AppleAuth from "./AppleAuth";
// @ts-expect-error pure js
import { getPromoCode, getUtmParams, setUtmSearchParams } from "../../utils";
// @ts-expect-error pure js
import useAuth from "../../hooks/use-auth.js";
import Text from "../../components/UI/Text.tsx";

export default function LoginPage() {
  const location = useLocation();
  const [persistLogin, setPersistLogin] = useState(false);
  const [searchParams] = useSearchParams();
  const idParrain = searchParams.get("referral") || location.state?.referral;
  const utm = getUtmParams(searchParams) || location.state?.utm;
  const codePromo = getPromoCode(searchParams) || location.state?.promo;

  const {
    auth: { accessToken },
  } = useAuth();

  if (accessToken) {
    return <Navigate to="/" />;
  }

  const signupUrl = new URL("/signup", window.location.origin);
  if (idParrain) {
    signupUrl.searchParams.set("referral", idParrain);
  }
  if (codePromo) {
    signupUrl.searchParams.set("promo", codePromo);
  }
  if (utm) {
    setUtmSearchParams(signupUrl.searchParams, utm);
  }

  return (
    <TemplateAuthentication>
      <AuthHeader
        title="Se connecter à Qalimo"
        subtitle="Veuillez remplir le formulaire pour vous connecter."
      />
      <AuthForm onPersistLoginChange={setPersistLogin} />
      <div className={styles.divider}>
        <Text as="span">Ou</Text>
      </div>
      <GoogleAuth persistLogin={persistLogin} />
      <AppleAuth persistLogin={persistLogin} />
      <AuthFooter
        label="Vous n'avez pas de compte ?"
        linkText="Créer un compte"
        to={signupUrl.pathname + signupUrl.search}
        state={{
          from: location.state?.from ?? location,
          referral: idParrain,
          promo: codePromo,
          utm,
        }}
        replace
      />
    </TemplateAuthentication>
  );
}
